import { Stack } from '@mui/material'

import {
  TutorialStep,
  type TutorialStepProps
} from 'components/common/TutorialStep'

export function AuthenticationStep({
  children,
  badgeNumber,
  title,
  ...rest
}: TutorialStepProps) {
  return (
    <TutorialStep badgeNumber={badgeNumber} title={title} {...rest}>
      <Stack sx={{ alignItems: 'start', rowGap: 1 }}>{children}</Stack>
    </TutorialStep>
  )
}
